export const PATHS = {
    HOME: '/',
    BORROW: '/borrow',
    BORROW_DETAILS: '/borrow/:address',
    WALLET_CONNECT: '/wallet-connect',
    POOL_DETAILS: '/pool/:address',
    POOL_PERSONALISED: '/pool/personalised',
    POOL_PERSONALISED_SUCCESS: '/pool/personalised/success',
    ORDER_BOOK: '/order-book',
    ORDER_BOOK_BORROW: '/order-book/borrow',
    TERMS_AND_CONDITIONS: '/terms-and-conditions',
    VAULTS: '/vaults',
    VAULTS_MANAGE: '/vaults/manage',
    VAULTS_MANAGE_DETAILS: '/vaults/manage/:address',
    TEAM: '/team',
};
